export default "__VITE_PUBLIC_ASSET__54b1baad__"